

import React from "react";
import { DetailedHTMLProps, FC, SVGProps } from "react";
export const SubtractIcon: FC<
DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (

    <svg className={className} width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.3053 0.761597L1.3053 0.761596" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

);